<div id="duplicate-alert" class="esf-notification esf-notification--alert is-active" *ngIf="opened"
     style="position: fixed;
      z-index: 110;
      top: 0;
      left: 0;
      right: 0;">
  <div class="esf-container">
    <span i18n='@@customerOverview.notification.customerDuplicateNotification1'>
      This customer can not be edited, as the existing email address is already assigned to a different one.
    </span>
    <br>
    <span>
      {{ translatedString | translateCut:0 }}
      <a class="esf-button esf-button--simple" (click)="activate()">{{ translatedString | translateCut:1 }}</a>
      {{ translatedString | translateCut:2 }}
      <a class="esf-button esf-button--simple" (click)="newEmail()">{{ translatedString | translateCut:3 }}</a>.
    </span>
  </div>
  <div class="esf-notification__close">
    <svg class="esf-icon esf-icon--white" width="16" height="16" (click)="close()">
      <use xlink:href="#esf-icon-close"></use>
    </svg>
  </div>
</div>
